import { accountService } from '@/projects/admin/services/account-service';
import { t } from 'i18next';
import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import { createCustomStore } from '@/core/wrappers/custom-store-wrapper';

const AccountListByType = () => {
    const params = useParams();
    const accountType = params.accountType;

    const [store] = useState(createCustomStore({
        key: 'id',
        load: accountService.lookupAccounts,
        byKey: (key, loadOptions) => {
            if (key) {
                loadOptions.filter = ["id", "=", key];
            }
        },
        onLoading(loadOptions) {
            loadOptions.filter = ["AccountType", "=", accountType]
        },
    }));

    const navigate = useNavigate();
    const goToEdit = (id: string) => {
        navigate(`/admin/account-definition/${id}`, { state: { id: id } })
    }

    return (
        <>
            <DataGridWrapper
                datasource={store}
                permissonCode='Admin.Account.Account'
                pagerVisible={true}
                filterVisible={true}
                headerFilterVisible={true}
                sortingMode='none'
                enableCustomToolbarContent={true}
                searchPanelVisible={true}
                columnChooser={true}
                isAddNewBtn={true}
                navigateNewRecordPath='/admin/account-definition'
                editingConfig={{
                    allowDeleting: true,
                    allowUpdating: true,
                    deleteMessageText: RemoveMessage('Account'),
                }}
                columns={[
                    { dataField: 'name', caption: t('account_name'), allowFiltering: false },
                    { dataField: 'accountNumber', caption: t('account_number'), allowFiltering: false },
                    { dataField: 'parentAccountName', caption: t('parent_account'), allowFiltering: false }
                ]}
                buttonConfig={[
                    {
                        name: 'edit',
                        icon: 'edit',
                        onClick: function (e: any) {
                            goToEdit(e.row?.data.id);
                        },
                    },
                    {
                        name: 'delete',
                        icon: 'trash',
                    },
                ]}
            />
        </>
    )
}
export default AccountListByType;